<main class="request-shell my-requests-page">
  <app-landing-header />

  <section class="requests-heading">
    <button class="heading-action" type="button" (click)="goHome()" [attr.aria-label]="preferences.t('navigation.home')">
      <app-icon name="chevron-right" />
    </button>
    <h1>{{ preferences.t('myRequests.submittedTitle') }}</h1>

  </section>

  @if (isLoading) {
    <p class="requests-state">{{ preferences.t('common.states.loading') }}</p>
  } @else if (errorMessage) {
    <p class="requests-state is-error">{{ errorMessage }}</p>
  } @else if (!requests.length) {
    <p class="requests-state">{{ preferences.t('common.states.empty') }}</p>
  } @else {
    <section class="requests-list" aria-label="requests">
      @for (request of requests; track $index) {
        <article class="request-card">
          <header class="request-card-head">
            <div class="request-badges">
              <span
                class="request-status"
                [class.inprogress]="request.statusClass === 'inprogress'"
                [class.cancelled]="request.statusClass === 'cancelled'"
                [class.approved]="request.statusClass === 'approved'"
              >
                {{ request.status }}
              </span>
              @if (request.showTag) {
                <span class="request-tag">{{ request.tag }}</span>
              }
            </div>
            <span>{{ request.date }}</span>
          </header>

          <div class="request-card-body">
            <span class="request-user" aria-hidden="true">
              <img src="/assets/images/global/user.svg" alt="" />
            </span>
            <h2>{{ request.title }}</h2>
            <div class="request-amount">
              <small>{{ preferences.t('financeLabels.amountLabel') }}</small>
              <strong>
                <img src="/assets/images/global/riyal-icon.svg" alt="" />
                {{ request.amount }}
              </strong>
            </div>
            <button
              class="request-details-button"
              type="button"
              aria-label="details"
              (click)="openRequestDetails(request)"
            >
              <app-icon name="chevron-left" />
            </button>
          </div>

          <footer class="request-card-footer">
            <span class="monthly-installment">
              {{ preferences.t('financeLabels.monthlyInstallment') }}
              <strong class="inline-money">
                <img src="/assets/images/global/riyal-icon.svg" alt="" />
                {{ request.installment }}
              </strong>
            </span>
            <span>{{ preferences.t('financeLabels.fundDuration') }} <strong>{{ request.duration }}</strong></span>
          </footer>
        </article>
      }
    </section>
  }
</main>
